export { default } from './product-page-loading-state';
